/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForKubernetesAgentSyncStatus extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForKubernetesAgentSyncStatus.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForKubernetesAgentSyncStatus>): ProgressDetailsForKubernetesAgentSyncStatus {
        let obj = Object.assign(new ProgressDetailsForKubernetesAgentSyncStatus(), model);
        ProgressDetailsForKubernetesAgentSyncStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForKubernetesAgentSyncStatus>): ProgressDetailsForKubernetesAgentSyncStatus {
        if (!model) return null;
        return ProgressDetailsForKubernetesAgentSyncStatus.newInstance(<ProgressDetailsForKubernetesAgentSyncStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForKubernetesAgentSyncStatus) {
        if (!obj) return;

        models.ProgressDetailsForKubernetesAgentSyncStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForKubernetesAgentSyncStatus): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForKubernetesAgentSyncStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.data_collection_start === "string") {
            this.data_collection_start = new Date(<string><any>this.data_collection_start);
        }
        if (typeof this.data_collection_end === "string") {
            this.data_collection_end = new Date(<string><any>this.data_collection_end);
        }
    }

    /**
     * run id from the agent about the sync
     */
    run_id: string;

    /**
     * log trace from the agent about the sync
     */
    log_trace: Array<string>;

    /**
     * Data Collection Start Datetime
     */
    data_collection_start: Date;

    /**
     * Data Collection end Datetime
     */
    data_collection_end: Date;

}
